export default __webpack_public_path__ + "static/media/Logo.339d717f.svg";